module.exports = __webpack_public_path__ + "img/CH_Williams_2010.a66295fe.png";